<template>
  <div>
    <header>
      <div class="left">
        <h2>Projects</h2>
        <p>
          Showing {{ project_count }} of {{ total_projects }} result{{
            total_projects === 1 ? '' : 's'
          }}
        </p>
      </div>

      <div class="right">
        <a class="main-action second-action" @click="download_CSV()"
          >Export CSV</a
        >
        <a class="main-action" @click="new_project()">New project</a>
      </div>
    </header>

    <div>
      <div class="flex-between">
        <search-box :onChange="handleSearch" />

        <div class="flex-between pagination">
<!--          <a-->
<!--            v-if="app_user && ['SuperAdmin', 'Admin'].includes(app_user.role)"-->
<!--            class="outline-button mr-3"-->
<!--            @click="$router.push('project-templates')"-->
<!--          >-->
<!--            Project Templates-->
<!--          </a>-->

          <a class="outline-button" @click="showFilters()">
            <img src="~@/assets/icons/filters.svg" />
            Filters{{
              $store.getters.project_filters_count > 0
                ? ` (${$store.getters.project_filters_count})`
                : ''
            }}
          </a>

          <toggle-button
            v-if="app_user.role !== 'User'"
            label="Only my team"
            :value="filtered_by_my_cat"
            :onChange="toggleMyCategory"
          />

          <toggle-button
            v-if="app_user.role === 'User'"
            label="Only my projects"
            :value="filtered_to_include_me"
            :onChange="toggleMyProjects"
          />

          <pagination />
        </div>
      </div>

      <table class="acada-table" v-if="project_count">
        <colgroup>
          <col style="width: 18%" />
          <col style="width: 12%" />
          <col style="width: 9%" />
          <col style="width: 15%" />
          <col style="width: 8%" />
          <col style="width: 8%" />
          <col style="width: 8%" />
          <col style="width: 15%" />
          <col style="width: 7%" />
        </colgroup>

        <tr>
          <th>
            <table-header-cell
              label="Project name"
              :onChange="changeOrder"
              :options="detailSortOptions"
              :value="orderBy"
            />
          </th>
          <th>Team</th>
          <th>
            <table-header-cell
              label="Type"
              :onChange="changeOrder"
              :options="typeSortOptions"
              :value="orderBy"
            />
          </th>
          <th>Stakeholders</th>
          <th>
            <table-header-cell
              label="Spend"
              :onChange="changeOrder"
              :options="spendSortOptions"
              :value="orderBy"
            />
          </th>
          <th colspan="2" style="text-align: center">
            Benefits
            <div class="d-flex justify-content-around">
              <div style="text-align: center">Forecast</div>
              <div style="text-align: center">Realised</div>
            </div>
          </th>
          <th>
            <table-header-cell
              label="Dates"
              :onChange="changeOrder"
              :options="dateSortOptions"
              :value="orderBy"
            />
          </th>
          <th>Progress</th>
        </tr>

        <tr
          v-for="project of projects"
          :key="project.id"
          @click="go_to_project(project.shortId)"
        >
          <td>
            <div class="details">
              <!--<div class="img" :style="{backgroundImage: `url(${project.logo})`}"></div>-->
              <div class="right">
                <h4>{{ project.name }}</h4>
                <div class="d-flex align-items-center">
                <span class="status" :class="project.status.toLowerCase()">
                  {{ project.status }}
                </span>
                  <img v-if="project.private" class="ml-1" height="18px" width="18px" src="~@/assets/icons/lock.svg" />
                </div>
              </div>
            </div>
          </td>

          <td>
<!--            {{-->
<!--              categories[project.categoryId]-->
<!--                ? categories[project.categoryId].name-->
<!--                : '-'-->
<!--            }}-->
<!--            TODO: Maybe this should be some sort of path-->
            {{project.category ? project.category.name : '-'}}
          </td>

          <td>{{ project.type }}</td>

          <td>
            <div class="stakeholders">
              <stakeholder
                style="z-index: 4"
                :list="project.owners"
                v-tooltip="{
                  content: ownersPopoverContent(project),
                  classes: 'large',
                }"
              />
              <stakeholder
                style="z-index: 3"
                :list="project.sponsors"
                v-tooltip="{
                  content: sponsorsPopoverContent(project),
                  classes: 'large',
                }"
              />
              <stakeholder
                style="z-index: 2"
                :list="project.members"
                v-tooltip="{
                  content: keyStakeholderPopoverContent(project),
                  classes: 'large',
                }"
              />
              <stakeholder
                style="z-index: 1"
                :list="project.others"
                v-tooltip="{
                  content: otherMembersPopoverContent(project),
                  classes: 'large',
                }"
              />
            </div>
          </td>

          <td>
            {{ formatCurrency(project.estAnnualSpend, project.currencyId) }}
          </td>

          <td style="text-align: center">
            <span
              v-tooltip="{
                content: forecastedBenefitsPopoverContent(project),
                delay,
                classes: 'large',
              }"
              >{{
                formatCurrency(project.forecasted_benefits, project.currencyId)
              }}</span
            >
          </td>

          <td style="text-align: center">
            <span
              v-tooltip="{
                content: benefitsPopoverContent(project),
                delay,
                classes: 'large',
              }"
            >{{
                formatCurrency(project.total_benefits, project.currencyId)
              }}</span
            >
          </td>

          <td class="dates">
            {{ formatDate(project.startDate, 'From') }}
            <i class="material-icons">arrow_forward</i>
            {{ formatDate(project.dueDate, 'To') }}
          </td>

          <td>
            <donut
              :percent="calculateActionCompletion(project)"
              backgroundColor="#E4E7ED"
              foregroundColor="#65CDB5"
              classValue="donut amount"
              :strokeWidth="14"
              :radius="90"
              :width="50"
              :height="50"
              :visibleValue="true"
              emptyText="0%"
            >
              <span>{{ calculateActionCompletion(project) }}%</span>
            </donut>
          </td>
        </tr>
      </table>

      <div v-else class="no-data">No projects to show</div>
    </div>

    <project-filters :onApply="getProjects" />
  </div>
</template>

<script>
import moment from 'moment';
import currency from '../utils/currency';
import SearchBox from '../components/SearchBox';
import Pagination from '../components/Pagination';
import Stakeholder from '../components/Stakeholder';
import ProjectFilters from '../components/ProjectFilters';
import TableHeaderCell from '../components/TableHeaderCell';
import benefitsPopover from '../utils/benefitsPopover';
import membersPopover from '../utils/membersPopover';
import ToggleButton from '../components/ToggleButton';
import DoughnutChart from 'vue-doughnut-chart';
import { mapGetters } from 'vuex';

export default {
  name: 'Projects',
  data() {
    return {
      dataRetrieved: false,
      delay: { show: 700, hide: 0 },
      detailSortOptions: [
        { text: 'Project Name A-Z', value: 'name|ASC' },
        { text: 'Project Name Z-A', value: 'name|DESC' },
        { text: 'Status A-Z', value: 'status|ASC' },
        { text: 'Status Z-A', value: 'status|DESC' },
      ],
      categorySortOptions: [
        { text: 'Category A-Z', value: 'category.name|ASC' },
        { text: 'Category Z-A', value: 'category.name|DESC' },
      ],
      spendSortOptions: [
        { text: 'Low to High', value: 'estAnnualSpend|ASC' },
        { text: 'High to Low', value: 'estAnnualSpend|DESC' },
      ],
      typeSortOptions: [
        { text: 'Type A-Z', value: 'type|ASC' },
        { text: 'Type Z-A', value: 'type|DESC' },
      ],
      dateSortOptions: [
        { text: 'Start (earliest)', value: 'startDate|ASC' },
        { text: 'Start (latest)', value: 'startDate|DESC' },
        { text: 'Due (earliest)', value: 'dueDate|ASC' },
        { text: 'Due (latest)', value: 'dueDate|DESC' },
      ],
    };
  },
  computed: {
    ...mapGetters(['currencyCodeById', 'rootCategory']),
    app_user() {
      return this.$store.getters.app_user || {};
    },
    projects() {
      if (!this.dataRetrieved) return {};
      return this.$store.getters.projects;
    },
    project_count() {
      return Object.keys(this.projects).length;
    },
    categories() {
      return this.$store.getters.categories;
    },
    project_filters() {
      return this.$store.getters.project_filters;
    },
    pagination_trigger() {
      return this.$store.getters.pagination_trigger;
    },
    search_term() {
      return this.$store.getters.search_term;
    },
    page() {
      return this.$store.getters.page;
    },
    perPage() {
      return this.$store.getters.perPage;
    },
    orderBy() {
      return this.$store.getters.orderBy;
    },
    total_projects() {
      return this.$store.getters.total_projects;
    },
    filtered_by_my_cat() {
      const cat_filters = this.project_filters.categoryId;
      if (!cat_filters) return false;

      const { categoryId, relatedCategories } = this.app_user;

      // create a set containing all the category ids for the user, if relatedCategories is defined
      const userCategoryIds = new Set([...(relatedCategories.map(el => el.id) || []), categoryId]);

      // fetch the category objects for each user category id
      const userCategories = Array.from(userCategoryIds).map(id => this.rootCategory[id]);

      // create a set containing all the filtered ids
      const filteredIdsSet = new Set(cat_filters);

      // fetch the category objects for each filtered id
      const filteredCategories = cat_filters.map(id => this.rootCategory[id]);

      // check if the sets are equal (i.e., if filteredIds contains only the user's category ids)
      return (filteredIdsSet.size === userCategoryIds.size) &&
        userCategories.every(category => filteredCategories.includes(category));
    },
    filtered_to_include_me() {
      const team_filters = this.project_filters.teamMembers;
      if (!team_filters) return false;

      return team_filters.length === 1 && team_filters[0] === this.app_user.id;
    },
  },
  methods: {
    getParams(get_all_data = false) {
      const order = this.orderBy.split('|');

      const params = [
        { key: 'limit', value: get_all_data ? 100000 : this.perPage },
        {
          key: 'offset',
          value: get_all_data ? 0 : (this.page - 1) * this.perPage,
        },
        { key: 'orderBy', value: order[0] },
        { key: 'order', value: order[1] },
      ];

      if (this.search_term) {
        params.push({ key: 'search', value: this.search_term });
      }

      Object.keys(this.project_filters).forEach(key => {
        let value = this.project_filters[key];

        if (Array.isArray(value)) {
          value = value.filter(v => v !== 'All');
        }

        if (value && value.length) {
          params.push({ key, value });
        }
      });

      return params;
    },
    async getProjects() {
      const params = this.getParams();
      const projects = await this.$store.dispatch('getProjects', params);

      if (projects) {
        this.$store.dispatch('setTotalProjects', projects.totalSize);
      }
    },
    async download_CSV() {
      try {
        const params = this.getParams(true);
        const data = await this.$store.dispatch('getProjectsCSV', params);

        const blob = new Blob([data], { type: 'text/csv' });
        const href = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.setAttribute('href', href);
        link.setAttribute('download', 'projects.csv');
        link.click();
      } catch (e) {
        console.log(e);
      }
    },
    handleSearch(searchTerm) {
      this.$store.dispatch('setSearchTerm', searchTerm);
      this.$store.dispatch('setPage', 1);
      this.getProjects();
    },
    changeOrder(param) {
      this.$store.dispatch('setOrderBy', param);
      this.$store.dispatch('setPage', 1);
      this.getProjects();
    },
    new_project() {
      this.$store.dispatch('setProjectModalView', 'details');
      this.$store.dispatch('setProjectModalID', -1);
    },
    go_to_project(id) {
      this.$store.dispatch('setProjectFiltersVisible', false);
      this.$router.push({ name: 'ProjectDetail', params: { id } });
    },
    formatDate(date, fallback) {
      if (!date) {
        return fallback;
      }
      return moment(date).format('D MMM YYYY');
    },
    formatCurrency(num, currencyId) {
      currency.locale(currencyId ? this.currencyCodeById(currencyId) : '');
      return currency(num).format('$0a.[0]');
    },
    benefitsPopoverContent(project) {
      return benefitsPopover(project);
    },
    forecastedBenefitsPopoverContent(project) {
      return benefitsPopover(project, true);
    },
    ownersPopoverContent(project) {
      return membersPopover(project, 'Owner');
    },
    sponsorsPopoverContent(project) {
      return membersPopover(project, 'Sponsor');
    },
    keyStakeholderPopoverContent(project) {
      return membersPopover(project, 'Team');
    },
    otherMembersPopoverContent(project) {
      return membersPopover(project, 'Other');
    },
    showFilters() {
      this.$store.dispatch('setProjectFiltersVisible', true);
    },
    toggleMyCategory(bool) {
      const getRootCategories = () => {
        let filteredIds = [];

        // add the categoryId to the filteredIds array
        filteredIds.push(this.app_user.categoryId);

        // if relatedCategories is defined, add its values to the filteredIds array
        if (this.app_user.relatedCategories) {
          filteredIds = filteredIds.concat(this.app_user.relatedCategories.map(el => el.id));
        }

        // remove any duplicate values from the filteredIds array
        filteredIds = [...new Set(filteredIds)];

        // map each id to its corresponding category object
        return filteredIds.map(id => this.rootCategory[id]);
      }
      const cat_filters = bool ? getRootCategories() : ['All'];
      this.$store.dispatch('setProjectFilter', {
        key: 'categoryId',
        value: cat_filters,
      });
      this.$store.dispatch('setPage', 1);
      this.getProjects();
    },
    toggleMyProjects(bool) {
      const team_filters = bool ? [this.app_user.id] : ['All'];
      this.$store.dispatch('setProjectFilter', {
        key: 'teamMembers',
        value: team_filters,
      });
      this.$store.dispatch('setPage', 1);
      this.getProjects();
    },
    calculateActionCompletion(project) {
      // if the project is marked as completed, we can return 100%, else it's automatically 0
      if (!project.actions) return project.status === 'Completed' ? 100 : 0;
      return Math.round((100 * project.completedActions) / project.actions);
    },
  },
  components: {
    'search-box': SearchBox,
    pagination: Pagination,
    stakeholder: Stakeholder,
    'table-header-cell': TableHeaderCell,
    'project-filters': ProjectFilters,
    'toggle-button': ToggleButton,
    donut: DoughnutChart,
  },
  async created() {
    if (!this.dataRetrieved) {
      await this.getProjects();
      this.dataRetrieved = true;
    }

    this.$ga.page('/projects');
  },
  watch: {
    pagination_trigger() {
      this.getProjects();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.flex-between {
  /* some rules also in common.scss */
  margin-top: 25px;

  &.pagination {
    margin-top: 0;
  }
}

::v-deep .doughnut_chart {
  width: 50px;

  .donut.amount {
    font-weight: 500;
    font-size: 14px;
    color: $sidebar-color;
    text-align: center;
    position: relative;
    top: -1px;
  }
}

.no-data {
  width: 100%;
  text-align: center;
  font-size: 14px;
  margin: 30px 0;
  color: $sidebar-color;
  opacity: 0.5;
}
</style>
